<template>
	<div v-if="installation !== undefined">
		<installations-infos :key="key_update"/>
		<v-row class="mb-2 px-4 pb-2">
			<v-col :class="selected_mode == '_installation_' ? 'col-9' : 'col-12'">
				<div class="d-flex" style="align-items: center">
					<div
						class="mode-choice"
						v-for="mode in modes"
						:key="mode"
						:class="{ active: mode == selected_mode }"
						@click="selected_mode = mode"
					>
						{{ $t(mode) }}
					</div>
				</div>
        <installations-diag v-if="selected_mode === '_bilan_sante_' && this.installation.has_alarm_data === 'true'"/>
				<installations-evo-perf
          :key="key_update + 1"
					:mode="selected_mode"
          :installation="installation"
          v-if="selected_mode != '_bilan_sante_'"
				/>
        <installationsonduleurs
          :key="key_update"
          v-if="selected_mode === '_vue_onduleurs_'"
				/>
        <installations-subarrays
          :key="key_update"
          v-if="selected_mode === '_vue_geometrique_'"
				/>
			</v-col>
			<installations-details-perf
				v-if="selected_mode === '_installation_'"
        :installation="installation"
			/>
		</v-row>
	</div>
</template>
<script>
import { mapGetters } from "vuex";
import InstallationsInfos from "@/components/Installations/Infos";
import InstallationsEvoPerf from "@/components/Installations/EvoPerf";
import InstallationsDiag from "@/components/Installations/Diagnostic";
import InstallationsSubarrays from "@/components/Installations/Subarrays";
import InstallationsDetailsPerf from "@/components/Installations/DetailsPerf";
import installationsonduleurs from "@/components/Installations/Onduleurs";
import webconf from "../../utils/frontend_setup";


export default {
	components: {
		InstallationsInfos,
		InstallationsEvoPerf,
    InstallationsDiag,
		InstallationsSubarrays,
		InstallationsDetailsPerf,
    installationsonduleurs,
	},

	data() {
		return {
      script_name: "Show.vue (Dashboard Niv2)",
      selected_mode: null,
			modes: [],
			installation: null,
      key_update: 0,
		};
	},

	computed: {
    ...mapGetters(["role", "installations", "cur_install_id", "constants"]),

		dates() {
      webconf.debugLog('computed', this.script_name,'dates : this.$store.state.parametersStore.dates',
          this.$store.state.parametersStore.dates
      )

			return this.$store.state.parametersStore.dates;
		},
	},

	watch: {
    '$route.params.id': {
      handler: function() {
        this.setInstallation()

        // Set Expert date for routing
        this.$store.dispatch("setInstallationExpertDate", {
          start_date: null,
          end_date: null
        })

        this.modes = []

        if (!this.isContinuousMenu()) {          
          if (this.installation.has_alarm_data === 'true') {
            this.selected_mode = '_bilan_sante_'          
            this.modes.push('_bilan_sante_')
          } else {
            this.selected_mode = '_installation_'
            this.modes.push('_installation_')
          
          }         
          this.modes.push('_vue_onduleurs_')
          if (this.checkaudit()) {
            this.modes.push('_vue_geometrique_')
          }
                   
        }
        else
        {
          const found = this.installation.elec_var.includes("Pac@grid");
          if (found){
            this.selected_mode = '_installation_'
            this.modes.push('_installation_')
          }
          else{
            this.selected_mode = '_installation_'
            this.modes.push('_installation_')
            this.modes.push('_vue_onduleurs_')            
          }       
          
          if (this.checkaudit()) {
            this.modes.push('_vue_geometrique_')
          }

        }
      },
      deep: true,
      immediate: true
    },

    '$root.$i18n.locale': {
      handler() {
        this.key_update += 1
      },
      deep: true,
      immediate: true,
    },

		selected_mode: {
			handler(val) {
        webconf.debugLog('watch', this.script_name,'selected_mode',
            `mode : ${this.selected_mode}`
        )

				let method = ""
        if (val === "_installation_") {
          method = "getInstallationLoss"
        }

        if (method.length > 0) {
          this.$store
              .dispatch(method, {
                id_ref_site: this.$route.params.id,
                start: this.$store.state.parametersStore.dates.start,
                end: this.$store.state.parametersStore.dates.end
              })
              .then(() => {
                this.setInstallation()
              });
        }
			},
      deep: true,
		},

		dates: {
			handler() {
        webconf.debugLog('watch', this.script_name,'dates',
            this.$store.state.parametersStore.dates
        )

				let method = ""
        if (this.selected_mode === "_installation_") {
          method = "getInstallationLoss"         
        }

        if (method.length > 0) {
          this.$store
              .dispatch(method, {
                id_ref_site: this.$route.params.id,
                start: this.$store.state.parametersStore.dates.start,
                end: this.$store.state.parametersStore.dates.end
              })
              .then(() => {
                this.setInstallation()
              });
        }
			},
			immediate: true,
			deep: true,
		},
	},

	methods: {
    checkaudit() {
      let res = true;

      this.installations.forEach(element => {
        if (element.installation_id == this.cur_install_id) {
          if (element.dc_analysis == false) {
            res = false;
          }
        }
      });
      return res;
    },

    isContinuousMenu() {
      return this.installation.target_menu === "continuous"
    },

		setInstallation() {
			this.installation = this.$store.getters.installations.find(
				(x) => x.id == this.$route.params.id
			);

      webconf.debugLog('methods', this.script_name,'setInstallation',
        this.installation
      )
		},

	},
};
</script>

<style>
.v-application a {
	text-decoration: none;
}
.v-chip {
	cursor: pointer;
}

.input {
	border: 1px solid #ededed !important;
	border-radius: 5px;
	cursor: pointer;
	padding: 1px 10px;
}

.mode-choice {
	text-transform: capitalize;
	font-size: 18px;
	padding: 8px 20px;
	font-weight: 500;
	border-radius: 4px 4px 0 0;
}

.mode-choice.active {
	background-color: white;
	cursor: default;
}

.mode-choice:not(.active) {
	background-color: rgba(100%, 100%, 100%, 0.5);
	cursor: pointer;
}
</style>
